import { Typography, useTheme } from '@mui/material'

interface INoDataMsgProps {
  message: string
}

export const NoDataMsg = ({ message }: INoDataMsgProps) => {
  const theme = useTheme()

  return (
    <Typography variant="body1" color={theme.palette.custom.grey2}>
      {message}
    </Typography>
  )
}
